import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuModel } from '../../models/common/menu.model';
import { MAIN_MENU } from '../../constants/menu';
import { SidebarService } from '../../services/sidebar.service';


@Component({
  selector: 'careposi-mobile-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './mobile-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MobileLayoutComponent  implements OnInit  {
  sidebarExpanded: boolean = false;
  sidebarMenu: MenuModel[] = MAIN_MENU;
  @Output() toggleSidebar = new EventEmitter();
  
  constructor(private sidebarService: SidebarService) {}

  ngOnInit(): void {
    this.sidebarService.setMinMaxWidth(0 , 0);
  }
  handleToggleSidebar(value: any) {
    this.sidebarExpanded = value;
    this.toggleSidebar.emit(value);
  }

}
